/////////////////////////////////////////////////////
//GLOBAL AMONG ALL MODULES, INCLUDING WEB APPS///////
/////////////////////////////////////////////////////
var globalConfig = {};
// NodeJs Specific Check
if (typeof module === "object" && module && module.exports) {
    globalConfig = module.exports;
}

var mitekSupportedFileTypes = ["jpg", "png", "jpeg"];
var standardDocumentValidFileTypes = ["jpg", "png", "pdf", "jpeg"];
// Time for "Quicken Loans" to transition to "Rocket Mortgage" publicly
var projectVoyagerDate = new Date('2021-07-31T00:00:00-0400');

/**********************************************************
 RocketLoans Company Name and info (Credco and others need this)
 **********************************************************/

globalConfig.company = {
    name: "Rocket Loans",
    address: {
        street: "1050 Woodward Ave",
        city: "Detroit",
        state: "MI",
        postalCode: "48226"
    },
    phone: {
        long: "(800) 333-7625",
        dash: "1-800-333-7625",
        solarSupportLong: "(833) 202 - 4366",
        solarSupportDash: "833-202-4366",
        solarSalesLong: "(855) 339 - 1831",
        solarSalesDash: "855-339-1831",
        dashNoCountryCode: "800-333-7625",
        servicing: "(313) 230-5233",
        servicingDash: "313-230-5233",
        hardshipAssistance: "313-230-5233"
    },
    email: {
        support: "Support@RocketLoans.com",
        marketing: "Marketing@RocketLoans.com",
        business: "BusinessDevelopment@RocketLoans.com",
        servicing: "Servicing@RocketLoans.com",
        solarSupport: "solarsupport@rocketloans.com",
        solarSales: "help@palmetto.com",

    },
    officeHoursWeek: "9:00 am - 7:00 pm ET",
    officeHoursSat: "9:00 am - 6:00 pm ET",
    officeHoursSun: "11:00 am - 2:00 pm ET",
    servicingOfficeHoursWeek: "9:00 am - 7:00 pm ET",
    servicingOfficeHoursSat: "9:00 am - 6:00 pm ET",
    officeDaysWeek: "Monday - Friday",
    officeDaySat: "Saturday",
    officeDaySun: "Sunday",
    timezone: "America/Detroit",
    checkMailingAddress: {
        street: "28596 Network Place",
        city: "Chicago",
        state: "IL",
        zip: "60673-1285"
    }
};

/** Controls whether we should be using the 7/31 rebranding for verbiage and
 * site themes */
globalConfig.isProjectVoyagerLive = new Date() > projectVoyagerDate;

globalConfig.status375ItemsName = {
    titleCaseSingular: "Tracking Item",
    lowerCaseSingular: "tracking item",
    lowerCamelCaseSingular: "trackingItem",
    upperCamelCaseSingular: "TrackingItem",
    titleCase: "Tracking Items",
    lowerCase: "tracking items",
    lowerCamelCase: "trackingItems",
    upperCamelCase: "TrackingItems"
};

globalConfig.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
globalConfig.monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
globalConfig.days = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31
];
globalConfig.years = generateYearsArray(100, 18);
globalConfig.twnfyStartYears = generateYearsArray(65, 0);
globalConfig.loanTapeYears = generateYearsArray(5, -1);

function generateYearsArray(length, offset) {
    var arr = [];

    for (var i = 0; i < length; i++) {
        arr.push(new Date().getFullYear() - offset - i);
    }

    return arr;
}

globalConfig.client = {
    minimumIdScore: 75
};

globalConfig.fastFundMaxAmount = 9999;

// What does 'active' do on these document types?
// It looks like it makes it available to manually add that twnfy item to a loan from the admin.

globalConfig.documentTypes = {
    identityVerification: {
        label: "Identity Verification",
        types: {
            // TYPE CODES MUST BE UNIQUE TO identityVerification
            RAEV: {
                code: "RAEV",
                description: "Please verify the email address you used to create your Rocket Account. If you need a new verification email to be sent to you, please select the Send Verification Email button below to resend it. If you’ve already verified your email and you are still seeing this message, select the Check Status button below.",
                text: "Verify Your Rocket Account Email Address",
                validFileTypes: [],
                // Setting this to true won't work, the rules function will need to be modified in order to request the TWNFY function if it's adminRequested: true
                active: false
            },
            BL: {
                code: "BL",
                description: "Please upload your current business license, professional license, current contract, or insurance document associating you (by name) to your business. Independent contractors please upload your most recent 1099.",
                text: "Proof of Self-Employment",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            DLF: {
                code: "DLF",
                description: "Please upload a clear, color photo of the front of your state issued ID card or driver's license making sure all four corners and edges are visible. If any of the text is not readable, or if the picture is blurry, please retake it.",
                text: "Photo ID (Front)",
                validFileTypes: mitekSupportedFileTypes,
                active: true
            },
            DLB: {
                code: "DLB",
                description: "Please upload a clear, color photo of the back of your state issued ID card or driver's license making sure all four corners and edges are visible. If any of the text is not readable, or if the picture is blurry, please retake it.",
                text: "Photo ID (Back)",
                validFileTypes: mitekSupportedFileTypes,
                active: true
            },
            EV: {
                code: "EV",
                description: "Please check your email and click on the link provided to verify your email address. If the message does not appear in your inbox, please check the spam folder or click the link below to resend.",
                text: "Verify Your Email Address",
                validFileTypes: standardDocumentValidFileTypes,
                // Setting this to true won't work, the rules function will need to be modified in order to request the TWNFY function if it's adminRequested: true
                active: true
            },
            LA: {
                code: "LA",
                description: "Please upload a copy of your Lease Agreement or Closing Disclosure for your current residence. This document should be signed and show your name and the address entered on your application.",
                text: "Lease Agreement or Closing Disclosure",
                validFileTypes: standardDocumentValidFileTypes,
                active: false
            },
            PP: {
                adminOnly: true,
                code: "PP",
                text: "Passport",
                validFileTypes: standardDocumentValidFileTypes,
                active: false
            },
            ML: {
                adminOnly: true,
                code: "ML",
                text: "Military ID",
                validFileTypes: standardDocumentValidFileTypes,
                active: false
            },
            PR: {
                code: "PR",
                description: "Please upload a current utility bill (dated within 30 days) or a copy of your signed mortgage. Please make sure the uploaded proof of residency clearly matches your name and address entered on your application.",
                text: "Proof of Residency",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            SLD: {
                adminOnly: true,
                code: "SLD",
                text: "Large Deposit Documentation",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            UT: {
                code: "UT",
                description: "Please upload a current (dated within 30 days) cable, internet or phone bill showing your name and the address entered on your application. Please note that we cannot accept any other type of utility bill.",
                text: "Cable, Internet or Phone Bill",
                validFileTypes: standardDocumentValidFileTypes,
                active: false
            },
            VC: {
                adminOnly: true,
                code: "VC",
                description: "Please upload a color photo of a voided check for the primary checking account you use to pay your bills. Your name and address must be present and cannot be handwritten. If you cannot provide a voided check, please upload a color image of an official letter from your bank outlining your name, account number and routing number. This document must be on your bank's official letterhead and notarized by the bank.",
                text: "Voided Check or Notarized Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            XX: {
                adminOnly: true,
                code: "XX",
                customOnly: true,
                text: "Other form of ID",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            XY: {
                adminOnly: true,
                code: "XY",
                text: "Unknown",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            XZ: {
                adminOnly: true,
                code: "XZ",
                customOnly: true,
                text: "RES",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            PVS: {
                code: "PVS",
                description: "Please upload a clear, color photo (selfie) of yourself holding your state issued ID card or driver's license close to your face. It is important that we clearly see both your face and the photo ID in the picture, and that you are holding the ID.",
                text: "Photo Verification (ID Selfie)",
                validFileTypes: mitekSupportedFileTypes,
                active: true
            },
            BC: {
                code: "BC",
                description: "Please upload a copy of the birth certificate for each child you claim as a dependent and whose benefits you receive.",
                text: "Birth Certificate",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            OFA: {
                code: "OFA",
                description: "OFAC Report",
                text: "OFAC",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                adminOnly: true,
                autoReview: true
            },
            PAN: {
                code: "PAN",
                description: "Panorama Report",
                text: "Panorama",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                adminOnly: true,
                autoReview: true
            },
            PI: {
                code: "PI",
                description: "Passive Income Calculation",
                text: "Passive Income",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                adminOnly: true,
                autoReview: true
            }
        }
    },
    incomeVerification: {
        label: "Income Verification",
        types: {
            // TYPE CODES MUST BE UNIQUE TO incomeVerification
            AID: {
                code: "AID",
                description: "Please upload documents to support any additional income you may have.",
                text: "Additional Income Documents",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            PYC: {
                code: "PYC",
                description: "Please upload your most recent pay stub supporting a minimum of 30 days history of employment. You can obtain a copy of your most recent pay stub by contacting your employer's human resources or payroll department.",
                text: "Current Pay Stub",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            PYP: {
                code: "PYP",
                description: "Please upload your second most recent pay stub supporting a minimum of 30 days history of employment. You can obtain a copy of your pay stub by contacting your employer's human resources or payroll department.",
                text: "Previous Pay Stub",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            W2: {
                code: "W2",
                description: "Please upload a copy of your most recent W-2 from your current employer. You can obtain a copy of your most recent W-2 by contacting your employer's human resources department.",
                text: "W-2",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            T1: {
                code: "T1",
                description: "If you included social security in your stated income, you can alternatively upload a copy of your SSA-1099.",
                text: "Social Security 1099",
                validFileTypes: standardDocumentValidFileTypes,
                active: false
            },
            T2: {
                code: "T2",
                description: "If you filed a Schedule C, please upload both pages.",
                text: "Tax Form 1040 Schedule C",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            T3: {
                code: "T3",
                description: "If you filed a Schedule E, please upload both pages of the Schedule E. (If joint filing, include your Schedule K-1)",
                text: "Tax Form 1040 Schedule E",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            T4: {
                code: "T4",
                description: "Please upload a copy of your most recently filed K-1 for each business listed on your Schedule E.",
                text: "Tax Form 1040 Schedule K-1",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            TX: {
                code: "TX",
                description: "Please upload pages 1 and 2 of your most recent 1040 tax form. Page 2 must be signed and dated.",
                text: "Tax Form 1040",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            SS: {
                code: "SS",
                description: "If you included social security in your stated income, please upload a copy of your award letter.",
                text: "Social Security Award Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: false
            }, // ssa.gov
            SST1: {
                code: "SST1",
                description: "Please upload a copy of your Social Security Award letter or most recent Social Security 1099",
                text: "Social Security Award Letter or Social Security 1099",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            STC: {
                code: "STC",
                description: "Please upload all pages of your most recent bank statement showing at least one month of account activity. Most online banks allow clients to export monthly bank statements as a PDF. If you do not bank online, please scan and upload a paper copy.",
                text: "Bank Statement",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            STP: {
                code: "STP",
                description: "Please upload all pages of your previous month's bank statement. Most online banks allow clients to export monthly bank statements as a PDF. If you do not bank online, please scan and upload a paper copy.",
                text: "Previous Bank Statement",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            PN: {
                code: "PN",
                description: "If you receive pension income and included it in your stated total income on the application, please upload a copy of your award letter or most recent 1099.",
                text: "Pension Award Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            }, // pbgc.gov
            DDSA: {
                code: "DDSA",
                description: "If you receive alimony and/or child support income and would like to have it considered for qualification, please provide copies of your divorce decree and/or other documents outlining the payment frequency and amount of the income received. The documentation must support a minimum of 36 months of continuance in order to be considered.",
                text: "Divorce Decree or Separation Agreement",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            COD: {
                code: "COD",
                description: "If you receive alimony and/or child support income and would like to have it considered for qualification, please provide copies of your divorce decree and/or other documents outlining the payment frequency and amount of the income received. The documentation must support a minimum of 36 months of continuance in order to be considered.",
                text: "Court Ordered Documentation",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            OT: {
                adminOnly: true,
                code: "OT",
                customOnly: true,
                text: "Other proof of income",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            UN: {
                adminOnly: true,
                text: "Unknown",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            },
            IRA: {
                code: "IRA",
                description: "Please upload a copy of your most recent 401(k) or IRA year end statement. This statement should show your name, the amount of funds withdrawn for the year, and your remaining balance. Many financial institutions allow clients to export year end statements as a PDF.",
                text: "IRA/401k",
                validFileTypes: standardDocumentValidFileTypes,
                active: true
            }
        }
    },
    servicing: {
        label: "Servicing",
        types: {
            BRP: {
                code: "BRP",
                text: "Bankruptcy",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            HRS: {
                code: "HRS",
                text: "Hardship",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            HRSV2: {
                code: "HRSV2",
                text: "Hardship Application V2",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true,
                canClientGenerateDownloadUrl: true
            },
            POH: {
                code: "POH",
                text: "Proof of Hardship",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true,
                canClientGenerateDownloadUrl: true
            },
            PYA: {
                code: "PYA",
                text: "Payment Arrangement",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            SRM: {
                code: "SRM",
                text: "Servicing Misc.",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            DLL: {
                code: "DLL",
                text: "Delinquency Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            POA: {
                code: "POA",
                text: "Power of Attorney",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            CAD: {
                code: "CAD",
                text: "Cease and Desist Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            ACL: {
                code: "ACL",
                text: "Acceleration Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            PCL: {
                code: "PCL",
                text: "Pre-Acceleration Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            SEL: {
                code: "SEL",
                text: "Settlement Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            BKD: {
                code: "BKD",
                text: "Bank Document",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            DVL: {
                code: "DVL",
                text: "Debt Validation Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            TPA: {
                code: "TPA",
                text: "Third Party Authorization Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            CDL: {
                code: "CDL",
                text: "Credit Dispute Letter",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            ARDIS: {
                code: "ARDIS",
                text: "Archived Disclosure",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            SPLD: {
                code: "SPLD",
                text: "Stop Payment Lifted Document",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            POC: {
                code: "POC",
                text: "Proof of Claim",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            AMDP: {
                code: "AMDP",
                text: "Amended Plans",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            CNVN: {
                code: "CNVN",
                text: "Conversion Notice",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            EXA: {
                code: "EXA",
                text: "Exhibit A",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            FND: {
                code: "FND",
                text: "Final Decree",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            MOCN: {
                code: "MOCN",
                text: "Meeting of Creditors/341 Notice",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            OBJC: {
                code: "OBJC",
                text: "Objection of Claim",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            OCP: {
                code: "OCP",
                text: "Order Confirming Plan",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            ODC: {
                code: "OODC",
                text: "Order of Discharge",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            ODM: {
                code: "ODM",
                text: "Order of Dismissal",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            CH7: {
                code: "PC7",
                text: "Petition Coversheet Chapter 7",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            CH11: {
                code: "PC11",
                text: "Petition Coversheet Chapter 11",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            CH13: {
                code: "PC13",
                text: "Petition Coversheet Chapter 13",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            PLN: {
                code: "PLN",
                text: "Plan",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            RPN: {
                code: "RPN",
                text: "Redacted Prom Note",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
            SCHAJ: {
                code: "SCHAJ",
                text: "Schedules A-J",
                validFileTypes: standardDocumentValidFileTypes,
                active: true,
                autoReview: true
            },
        }
    },
    tuCapture: {
        tuIdentity: {
            code: "TUIDENTITY",
            description: "TransUnion TruValidate Identity Verification API response captures",
            text: "TruValidate Identity Verification API response",
            validFileTypes: ["json"],
            active: true,
            adminOnly: true,
            autoReview: true
        },
        tuDevice: {
            code: "TUDEVICE",
            description: "TransUnion TruValidate Digital/Device Verification API response captures",
            text: "TruValidate Digital/Device Verification API response",
            validFileTypes: ["json"],
            active: true,
            adminOnly: true,
            autoReview: true
        },
    }
};

globalConfig.loanTypes = {
    debtConsolidation: "Debt Consolidation",
    debtConsolidation_creditCard: "Pay Off Credit Cards",
    debtConsolidation_otherLoan: "Pay Off Other Loans",
    debtConsolidation_mortgage: "Pay Down Mortgage",
    homeImprovement: "Home Improvement",
    homeImprovement_repairs: "Home Repairs",
    medicalExpenses: "Medical Expenses",
    business: "Business",
    auto: "Auto",
    other: "Other"
};

globalConfig.employmentStatuses = {
    employed: "Employed",
    selfEmployed: "Self-Employed",
    retired: "Retired",
    other: "Other"
};

var tollFreeAreaCodes = [800, 888, 877, 866, 855, 844, 833];

globalConfig.militaryStates = ["AA", "AE", "AP"];

globalConfig.invalidStates = ["IA", "MD", "NV", "WV", ...globalConfig.militaryStates];

globalConfig.states = [
    "AK",
    "AL",
    "AR",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "HI",
    "IA",
    "ID",
    "IL",
    "IN",
    "KS",
    "KY",
    "LA",
    "MA",
    "MD",
    "ME",
    "MI",
    "MN",
    "MO",
    "MS",
    "MT",
    "NC",
    "ND",
    "NE",
    "NH",
    "NJ",
    "NM",
    "NV",
    "NY",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VA",
    "VT",
    "WA",
    "WI",
    "WV",
    "WY"
];

globalConfig.getValidStateCodeRegExp = function getValidStateCodeRegExp() {
    const { states, invalidStates } = globalConfig;
    const disallowedStates = new Set(invalidStates);

    const allowedStates = states.filter((state)=>!disallowedStates.has(state)).join('|');

    return new RegExp(`^(${allowedStates})$`, 'i');
};

globalConfig.validation = {
    inputMaxLength: 500,
    patterns: {
        firstName: /^[a-zA-Z\ ]+$/,
        firstNameNegated: /[^a-zA-Z\ ]/g,

        lastName: /^[a-zA-Z\ -]+$/,
        lastNameNegated: /[^a-zA-Z\ -]/g,

        // ^ beginning of string
        // (?=.*\d) lookahead to require at least 1 digit preceded by 0 or more of anything
        // [A-Za-z0-9# ]+ require first chars to be 1+ of these
        // [a-zA-Z0-9#.,'&\-\/ ]* may only include 0+ of these after first char (escaped "-" and "/")
        // $ end of string
        address: /^(?=.*\d)[A-Za-z0-9# ]+[a-zA-Z0-9#.,'&\-\/ ]*$/,
        addressNegated: /[^a-zA-Z0-9\.\,\#\-\/\ ]/g,

        city: /^[a-zA-Z0-9\-\'\.\ ]+$/,
        cityNegated: /[^a-zA-Z0-9\-\'\.\ ]/g,

        zip: /^\d{5}(-\d{4})?$/,

        email: /^([-a-z0-9~!$%^&_=+}{\'?]|\*(?!\*))+(\.([-a-z0-9~!$%^&_=+}{\'?]|\*(?!\*))+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|dev|app|solutions|engineering|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,

        // Local part allows RFC 5322 valid chars. Domain part must have one dot and allows alphanumeric and non-consecutive hyphens but not at start or end.
        emailPermissive: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9]+(-[a-z0-9]+)*(\.[a-z0-9]+(-[a-z0-9]+)*)+$/i,

        phone: RegExp("^(?!(" + tollFreeAreaCodes.join("|") + ")|(\\(" + tollFreeAreaCodes.join("|") + "\\)))(\\(\\d{3}\\)|\\d{3})[\\s\\.\\-]?\\d{3}[\\s\\.\\-]?\\d{4}$"),
        phoneBasic: /(^(\+\d{1,2}\s)?((\(\d{3}\))|\d{3})[\s\.\-]?\d{3}[\s\.\-]?\d{4}$)|^$/,
        tollFreeNumber: RegExp("^((" + tollFreeAreaCodes.join("|") + ")|(\\(" + tollFreeAreaCodes.join("|") + "\\)))[\\s\\.\\-]?\\d{3}[\\s\\.\\-]?\\d{4}$"),
        // Phone with 10 digits no special characters
        phoneNoFormat: RegExp("^(?!(" + tollFreeAreaCodes.join("|") + "))\\d{10}$"),
        validStateCodes: globalConfig.getValidStateCodeRegExp()
    }
};

globalConfig.loanLockExpiration = 20 * 60;
globalConfig.colorIdProhibitedStates = ["NC"];
globalConfig.minimumVerifiedIncome = 24000;
globalConfig.verifiedIncomeTolerance = 0.8;

globalConfig.incomeProviders = {
    plaid: "plaid",
    decisionLogic: "decisionLogic",
    manualVerification: "manualVerification",
    theWorkNumber: "theWorkNumber"
};

globalConfig.loanMin = 2000;
globalConfig.loanMax = 75000;

globalConfig.plaidPublicKey = "df0d4097a1a41a24b255ea533f19f8";

var sharedBankSearchFilter = [
    "card",
    "insurance",
    "canada",
    "united kingdom",
    "australia",
    "hsa",
    "fund",
    "pension",
    "paypal",
    "401",
    "403",
    "457",
    "529",
    "cash app",
    "kikoff"
];

globalConfig.decisionLogicSearchFilter = sharedBankSearchFilter.slice();

// add banks to array to be omitted from the bank search for Plaid
globalConfig.plaidSearchFilter = sharedBankSearchFilter.concat([]);


globalConfig.twnfyStates = require("../twnfy/states");
globalConfig.helpLinkConfig = require("./helpLinkConfig");
globalConfig.maxUploadFileSize = 15728640;
globalConfig.maxUploadFileSizeText = "15MB";

globalConfig.phoneMaskOptions = {
    addDefaultPlaceholder: false,
    allowInvalidValue: true,
    clearOnBlurPlaceholder: true,
    clearOnBlur: false,
    maskDefinitions: { 9: /\d/, 8: /[2-9]/ }
};
globalConfig.phoneMaskPattern = "(899) 999-9999";
globalConfig.phoneMaskPlaceholder = "(___) ___-____";

globalConfig.nextDayACHCuttoff = 14; //2PM EST

globalConfig.bankLogin = {
    reportStatusCodes: {
        REPORT_SUCCESS: 3,
        SUCCESSFUL_LOGIN: 1,
        BANK_COMM_ERR: -2,
        NOT_STARTED: 0
    }
};

globalConfig.creditReport = {
    validTimeFrameInMinutes: 5,
    expirationHours: 24,
    validProviders: ['equifax', 'transunion'],
};

globalConfig.underwritingCardPriority = require("../capitalMarkets/constants/preferredCardOrder");

globalConfig.api = {
    responseCodes: {
        errorCodes: {
            accountSuspended: {
                code: "ACCOUNT_SUSPENDED",
                status: 400
            },
            accountSuspendedFraud: {
                code: "CANNOT_PROCESS_ACCOUNT",
                status: 400
            },
            blockingClientOnRegistration: {
                code: "BLOCKING_CLIENT_ON_REGISTRATION",
                status: 400
            },
            createClientError: {
                code: "CREATE_CLIENT_ERROR",
                status: 500
            },
            createLoanError: {
                code: "CREATE_LOAN_ERROR",
                status: 500
            },
            creditPullError: {
                code: "CREDIT_PULL_ERROR",
                status: 500
            },
            creditModelFailure: {
                code: "CREDIT_MODEL_FAILURE",
                status: 500
            },
            creditNoHitFraud: {
                code: "CREDIT_NOHIT_FRAUD",
                status: 400
            },
            creditNoHitFreeze: { // Freeze on only Equifax, named as such because Equifax used to be only credit provider
                code: "CREDIT_NOHIT_FREEZE",
                status: 400
            },
            creditNoHitFreezeTu: {
                code: "CREDIT_NOHIT_FREEZE_TU",
                status: 400
            },
            creditNoHitFreezeEqTu: {
                code: "CREDIT_NOHIT_FREEZE_EQ_TU",
                status: 400
            },
            deniedByAdmin: {
                code: "DENIED_BY_ADMIN",
                status: 400
            },
            emailExists: {
                code: "EMAIL_EXISTS",
                status: 400
            },
            fetchError: {
                code: "FETCH_ERROR",
                status: 500
            },
            generateOffersError: {
                code: "GENERATE_OFFERS_ERROR",
                status: 500
            },
            hashPiiError: {
                code: "HASH_PII_ERROR",
                status: 500
            },
            hashSSNError: {
                code: "HASH_SSN_ERROR",
                status: 500
            },
            identity: {
                code: "IDENTITY",
                status: 400
            },
            identityUnrecoverable: {
                code: "IDENTITY_UNRECOVERABLE",
                status: 400
            },
            invalidCreditReportDate: {
                code: "INVALID_CREDIT_REPORT_DATE",
                status: 400
            },
            invalidLoan: {
                code: "INVALID_LOAN",
                status: 400
            },
            needRocketAccountUpgrade: {
                code: "NEEDS_ROCKET_ACCOUNT_LOGIN",
                status: 400
            },
            invalidRecaptcha: {
                code: "INVALID_RECAPTCHA",
                status: 400
            },
            invalidStatusState: {
                code: "INVALID_STATUS_STATE",
                status: 400
            },
            multipleAccounts: {
                code: "MULTIPLE_ACCOUNTS",
                status: 400
            },
            technicalIssues: {
                code: "TECHNICAL_ISSUES",
                status: 400
            },
            updateClientError: {
                code: "UPDATE_CLIENT_ERROR",
                status: 500
            },
            updateLoanError: {
                code: "UPDATE_LOAN_ERROR",
                status: 500
            },
            validationError: {
                code: "VALIDATION_ERROR",
                status: 400
            },
            offersMissing: {
                code: "OFFERS_MISSING",
                status: 500
            },
            offersSelectionFailed: {
                code: "OFFERS_SELECTION_FAILED",
                status: 500
            },
            offersCustomizePostVerification: {
                code: "OFFERS_CUSTOMIZE_POST_VERIFICATION",
                status: 500
            },
            loginMismatchedMergeClient: {
                code: "LOGIN_MISMATCHED_MERGE_CLIENT",
                status: 400
            },
            registrationFailed: {
                code: "REGISTRATION_FAILED",
                status: 400
            },
            communicationPreferencesError: {
                code: "COMMUNICATION_PREFS_ERROR",
                status: 400
            },
            alternateOfferSelectionError: {
                code: "ALTERNATE_OFFER_SELECTION_ERROR",
                status: 400
            },
            jwtUnauthorized: {
                code: "JWT_UNAUTHORIZED",
                status: 401
            },
            invalidSession: {
                code: "INVALID_SESSION",
                status: 403
            },
            invalidSessionRocketAccount: {
                code: "INVALID_SESSION_ROCKET_ACCOUNT",
                status: 403
            },
            registeredAccountExists: {
                code: "REGISTERED_ACCOUNT_EXISTS",
                status: 400
            },
            registeredAccountExistsRocketAccount: {
                code: "REGISTERED_ACCOUNT_EXISTS_ROCKET_ACCOUNT",
                status: 400
            },
            excessiveClientRecords: {
                code: "EXCESSIVE_CLIENT_RECORDS",
                status: 400
            },
            notAuthorized: {
                code: "NOT_AUTHORIZED",
                status: 403
            },
            accountUpgradeFailed: {
                code: "ACCOUNT_UPGRADE_FAILED",
                status: 400
            },
            leadCompleteFailed: {
                code: "LEAD_COMPLETE_FAILED",
                status: 500
            },
            registeredClientNotFound: {
                code: 'REGISTERED_CLIENT_NOT_FOUND',
                status: 400,
                msg: 'Registered Client not found by email'
            },
            clientNotFound: {
                code: 'CLIENT_NOT_FOUND',
                status: 400,
                msg: 'Client not found by email'
            },
            existingRaId: {
                code: "EXISTING_RAID",
                status: 403,
                msg: "Client already assigned to the requested raId"
            },
            raIdMismatch: {
                code: "RAID_MISMATCH",
                status: 403,
                msg: "Client already assigned to a different raId"
            },
            invalidClientId: {
                code: 'INVALID_CLIENTID',
                status: 400,
                msg: 'The clientId in the request was invalid or missing'
            },
            multipleRegisteredClientsFound: {
                code: 'MULTIPLE_REGISTERED_CLIENTS_FOUND',
                status: 409,
                msg: 'Multiple registered clients were found'
            },
            multipleClientsFound: {
                code: 'MULTIPLE_CLIENTS_FOUND',
                status: 409,
                msg: 'Multiple clients were found'
            },
            clientIdMismatch: {
                code: 'CLIENTID_MISMATCH',
                status: 409,
                msg: 'The client found does not match the provided clientId'
            },
            invalidCredentials: {
                code: 'INVALID_CREDENTIALS',
                status: 401,
                msg: 'Invalid login credentials were provided'
            },
            rocketAccountEmailNotYetVerified: {
                code: 'RA_EMAIL_UNVERIFIED',
                status: 403,
                msg: 'Email not verified yet'
            },
            rocketAccountEmailVerificationProcessing: {
                code: 'RA_EMAIL_PROCESSING',
                status: 403,
                msg: 'Email verification requested, not yet verified'
            },
            rocketAccountEmailVerificationStatusNotFound: {
                code: 'RA_EMAIL_NOT_FOUND',
                status: 500,
                msg: 'Expected rocket account email verification status was not found'
            },
            emailInUseAlready: {
                code: 'EMAIL_IN_USE_ALREADY',
                status: 409,
                msg: 'The email provided is already in use'
            },
            rocketAccountCreationFailure: {
                code: 'RA_ACCOUNT_CREATION_FAILURE',
                status: 500,
                msg: 'Rocket account was unable to process your account creation request'
            },
            loginMaxAttempts: {
                code: 'MAX_ATTEMPTS',
                status: 403,
                msg: 'Account locked due to incorrect login attempts'
            },
            passwordMissing: {
                code: 'NO_PASSWORD',
                status: 401,
                msg: 'Account password not set'
            },
            passwordExpired: {
                code: 'EXPIRED_PASSWORD',
                status: 403,
                msg: 'Account password expired'
            },
            invalidPasswordResetHash: {
                code: 'NOT_EXIST_HASH',
                status: 401,
                msg: 'Password Reset Hash does not exist'
            },
            weakPassword: {
                code: 'WEAK_PASSWORD',
                status: 400,
                msg: 'Password input is not strong enough'
            },
            routedApplicationNotFound: {
                code: 'ROUTED_APPLICATION_NOT_FOUND',
                status: 400,
                msg: 'No matching records were found using the loan application router token',
            },
            invalidAuthHeader: {
                code: 'INVALID_AUTH_HEADER',
                status: 401,
                msg: 'Missing or invalid authorization header'
            },
            authTokenFailure: {
                code: 'AUTH_TOKEN_FAILURE',
                status: 401,
                msg: 'Failed to authenticate authorization token'
            },
            defaultError: "DEFAULT_ERROR"
        },
        successCodes: {
            blockingClientInProgress: {
                code: "IN_PROGRESS_OR_SERVICING",
                status: 200
            },
            blockingClientInProgressRocketAccount: {
                code: "IN_PROGRESS_OR_SERVICING_ROCKET_ACCOUNT",
                status: 200
            },
            blockingClientIneligible: {
                code: "BLOCKING_CLIENT_INELIGIBLE",
                status: 200
            },
            blockingClientIneligibleRocketAccount: {
                code: "BLOCKING_CLIENT_INELIGIBLE_ROCKET_ACCOUNT",
                status: 200
            },
            creditPullSuccess: {
                code: "CREDIT_PULL_SUCCESS",
                status: 200
            },
            offersGenerated: {
                code: "OFFERS_GENERATED",
                status: 200
            },
            adverseAction: {
                code: "ADVERSE_ACTION",
                status: 200
            },
            registrationSuccess: {
                code: "REGISTRATION_SUCCESS",
                status: 200
            },
            offersRetrieved: {
                code: "OFFERS_RETRIEVED",
                status: 200
            },
            offersSelected: {
                code: "OFFERS_SELECTED",
                status: 200
            },
            offersSelectedEmailInUse: {
                code: "OFFERS_SELECTED_EMAIL_IN_USE",
                status: 200
            },
            offersSelectedRocketAccount: {
                code: "OFFERS_SELECTED_ROCKET_ACCOUNT",
                status: 200
            },
            offersSelectedRocketAccountNeedsMerge: {
                code: "OFFERS_SELECTED_ROCKET_ACCOUNT_NEEDS_MERGE",
                status: 200
            },
            offersSelectedRocketAccountNeedsLogin: {
                code: "OFFERS_SELECTED_ROCKET_ACCOUNT_NEEDS_LOGIN",
                status: 200
            },
            offersSelectedNeedsTrueUp: {
                code: "OFFERS_SELECTED_NEEDS_TRUE_UP",
                status: 200
            },
            offersSelectedRocketAccountNeedsTrueUp: {
                code: "OFFERS_SELECTED_ROCKET_ACCOUNT_NEEDS_TRUE_UP",
                status: 200
            },
            authCheckValid: {
                code: "AUTHCHECK_VALID",
                status: 200
            },
            communicationPreferencesSuccess: {
                code: "COMMUNICATION_PREFS_SUCCESS",
                status: 200
            },
            alternateOfferSelectionSuccess: {
                code: "ALTERNATE_OFFER_SELECTION_SUCCESS",
                status: 200
            },
            incomeVerified: {
                code: "INCOME_VERIFIED",
                status: 200
            },
            doneWithIncome: {
                code: "DONE_WITH_INCOME",
                status: 200
            },
            counterOffersAvailable: {
                code: "COUNTER_OFFER_AVAILABLE",
                status: 200
            },
            counterOffersUnavailable: {
                code: "COUNTER_OFFER_UNAVAILABLE",
                status: 200
            },
            selectedOfferExists: {
                code: "SELECTED_OFFER_EXISTS",
                status: 200
            },
            noOffersDTI: {
                code: "DTI",
                status: 200
            },
            trackingItemsPendingClient: {
                code: "TRACKING_ITEMS_PENDING_CLIENT",
                status: 200
            },
            accountCreateSuccess: {
                code: "ACCOUNT_CREATE_SUCCESS",
                status: 200
            },
            accountUpgradeSuccess: {
                code: "ACCOUNT_UPGRADE_SUCCESS",
                status: 200
            },
            leadCompleteSuccess: {
                code: "LEAD_COMPLETE_SUCCESS",
                status: 200
            },
            leadCompleteSuccessEmailInUse: {
                code: "LEAD_COMPLETE_SUCCESS_EMAIL_IN_USE",
                status: 200
            },
            leadCompleteSuccessNeedsMerge: {
                code: "LEAD_COMPLETE_SUCCESS_NEEDS_MERGE",
                status: 200
            },
            leadCompleteSuccessNeedsLogin: {
                code: "LEAD_COMPLETE_SUCCESS_NEEDS_LOGIN",
                status: 200
            },
            leadNeedsOfferSelect: {
                code: "LEAD_NEEDS_OFFER_SELECT",
                status: 200
            },
            raRegistrationReady: {
                code: "RA_REGISTRATION_READY",
                status: 200
            },
            raRegistrationReadyNeedsMerge: {
                code: "RA_REGISTRATION_READY_NEEDS_MERGE",
                status: 200
            },
            raRegistrationReadyNeedsLogin: {
                code: "RA_REGISTRATION_READY_NEEDS_LOGIN",
                status: 200
            },
        }
    }
};


globalConfig.prioritySleepDetails = {
    amount: 31,
    unit: "DAYS",
    activity: "ENTERED_P8",
    display: "ENTERED P8"
};

globalConfig.hardships = [
    {
        name: 'DISABILITY',
        subtypes: [
            'PERMANENT',
            'SHORT_TERM',
            'UNDISCLOSED'
        ]
    }, {
        name: 'INCREASE_IN_EXPENSES',
        subtypes: [
            'DIVORCE',
            'FUNERAL',
            'HOA_SPECIAL_ASSESSMENT',
            'INCREASED_PROPERTY_TAXES',
            'LEGAL_SEPARATION',
            'RELOCATION',
            'SEPARATION',
            'UNINSURED_LOSSES'
        ]
    }, {
        name: 'MANMADE_DISASTER',
        subtypes: [
            'CHEMICAL_SPILL',
            'GAS_LEAK'
        ]
    },
    {
        name: 'NATURAL_DISASTER',
        subtypes: [
            'COVID19',
            'EARTHQUAKE',
            'FLOOD',
            'HURRICANE',
            'TORNADO',
            'WILDFIRE'
        ]
    }, {
        name: 'REDUCTION_OF_INCOME',
        subtypes: [
            'EMPLOYMENT_TRANSFER',
            'GOVERNMENT_SHUTDOWN',
            'HOUSEHOLD',
            'LOSS_OF_OVERTIME',
            'LOSS_OF_SALARY',
            'LOSS_OF_WORK_HOURS',
            'UNEMPLOYED'
        ]
    }
];

globalConfig.aiwConfig = {
    validation: {
        checkbox: {
            validateOn: ['blur', 'change'],
            required: true,
            message: {
                default: 'Please choose at least one'
            }
        },
        inputField: {
            validateOn: ['blur', 'change'],
            required: true,
            message: {
                default: 'This field is required'
            }
        },
        select: {
            validateOn: ['blur', 'change'],
            required: true,
            message: {
                default: 'This field is required'
            }
        }
    },
    retirementIncomeOptions: [{
        id: 'aiw_retirement_pension',
        label: 'Pension',
        name: 'aiw_retirement_pension',
        value: 'pension'
    },
    {
        id: 'aiw_retirement_ssa',
        label: 'Social Security',
        name: 'aiw_retirement_ssa',
        value: 'ssa'
    },
    {
        id: 'aiw_retirement_ira_401k',
        label: 'IRA/401K',
        name: 'aiw_retirement_ira_401k',
        value: 'ira401k'
    }
    ],
    selfEmploymentIncomeOptions: [{
        id: 'aiw_self_employment_schedule_c',
        label: '1040 Schedule C',
        name: 'aiw_self_employment_schedule_c',
        value: 'scheduleC'
    },
    {
        id: 'aiw_self_employment_schedule_e',
        label: '1040 Schedule E',
        name: 'aiw_self_employment_schedule_e',
        value: 'scheduleE'
    }
    ],
    incomeTypes: {
        NO_MORE: 'noMore',
        RETIREMENT: 'retirement',
        PAYROLL: 'payroll',
        SELF_EMPLOYMENT: 'selfEmployment',
        COURT_ORDERED: 'courtOrdered'
    },
    sourceFlags: [
        "CLIENT_REPORTED_PENSION",
        "CLIENT_REPORTED_SSA",
        "CLIENT_REPORTED_IRA_401K",
        "CLIENT_REPORTED_PAYROLL",
        "CLIENT_REPORTED_SCHEDULE_C",
        "CLIENT_REPORTED_SCHEDULE_E",
        "CLIENT_REPORTED_COURT_ORDERED"
    ],
    sourceFlagNameMap: {
        CLIENT_REPORTED_PENSION: "Retirement - Pension",
        CLIENT_REPORTED_SSA: "Retirement - Social Security",
        CLIENT_REPORTED_IRA_401K: "Retirement - IRA/401K",
        CLIENT_REPORTED_PAYROLL: "Employment",
        CLIENT_REPORTED_SCHEDULE_C: "Self Employment - Schedule C",
        CLIENT_REPORTED_SCHEDULE_E: "Self Employment - Schedule E",
        CLIENT_REPORTED_COURT_ORDERED: "Alimony / Child Support"
    },
    nonDenialCodes: [
        "SELECTED_OFFER_UNAVAILABLE",
        "REQUESTED_AMOUNT_UNAVAILABLE",
        "APR_DECREASE",
        "APR_INCREASE"
    ],
    newOffersCodes: [
        "SELECTED_OFFER_UNAVAILABLE",
        "REQUESTED_AMOUNT_UNAVAILABLE",
        "APR_INCREASE"
    ],
    completeFlag: "AIW_FINISHED"
};

// response codes for RPC calls (http status code will usually be 200)
globalConfig.serviceCallbackResultCodes = {
    COMPLETE: 'complete',
    FAIL: 'failed'
};

/**
 * Apollo API Constants
 */
globalConfig.apollo = {
    truvalidate: {
        customerAddressTypes: [
            'conventional',
            'standard',
            'delivery',
            'billing'
        ],
        fileSupressedOrFrozenCodes: ["9022", "KMSG01"],
        likertQuantityLevels: [
            'high',
            'medium',
            'low'
        ],
        likertHistoryLevels: [
            'good',
            'suspicious',
            'bad'
        ],
        radActions: [
            'deny',
            'allow',
            'review'
        ],
        vendorSearchStatuses: {
            CLEAR: 'clear',
            AVAILABLE_CLEAR: 'availableClear',
            HIT: 'hit',
            NOT_PERFORMED: 'notPerformed',
            POTENTIAL_HIT: 'potentialHit'
        },
        verificationAnalysis: {
            matchResults: {
                NOT_FOUND: 'notFound',
                MATCH: 'match',
                MATCH_LAST_FOUR: 'matchLastFour',
                NO_MATCH: 'noMatch',
                PARTIAL_MATCH: 'partialMatch',
                INPUT_NOT_AVAILABLE: 'inputNotAvailable',
                MATCH_NOT_PERFORMED: 'matchNotPerformed'
            },
            sources: ['file', 'vendorFile', 'nonCreditFile'],
            statuses: {
                SUBJECT_FOUND: 'subjectFound',
                SUBJECT_NOT_FOUND: 'subjectNotFound'
            },
            phoneStatuses: ['nonDialable', 'dialable', 'unconfirmed'],
            restrictionStatuses: ['none'],
        }
    }
};

globalConfig.hardshipSignedStatusTypes = [
    "PENDING_DOC_UPLOAD",
    "PENDING_OPS_REVIEW",
    "PENDING_CLIENT_AGREEMENT",
    "RESOLVED"
];

globalConfig.hardshipUnsignedStatusTypes = [
    "PENDING_SIGNATURE"
].concat(globalConfig.hardshipSignedStatusTypes);

globalConfig.hardshipResultTypes = [
    "ABANDONED",
    "APPROVED",
    "CANCELLED",
    "DENIED"
];

globalConfig.investorAuditJobStatus = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
};

globalConfig.cookieManagerElementId = 'teconsent';

globalConfig.inactiveLoanStates = [
    'CANCELED',
    'DENIED',
    'LEAD_AGG_NO_APP',
    'PAID',
];

globalConfig.validLoanStates = [
    'APPLICATION',
    'DEFAULT',
    'SERVICING_NONPERFORMING',
    'SERVICING_PERFORMING',
    ...globalConfig.inactiveLoanStates,
];
